package team.platforma.multiplatform_material_extension.ui.core.global_style

import androidx.compose.material3.ButtonColors
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CheckboxColors
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color

object CheckBoxColorScheme {
    var checkedCheckmarkColor: Color? = null
    var uncheckedCheckmarkColor: Color? = null
    var checkedBoxColor: Color? = null
    var uncheckedBoxColor: Color? = null
    var disabledCheckedBoxColor: Color? = null
    var disabledUncheckedBoxColor: Color? = null
    var disabledIndeterminateBoxColor: Color? = null
    var checkedBorderColor: Color? = null
    var uncheckedBorderColor: Color? = null
    var disabledBorderColor: Color? = null
    var disabledUncheckedBorderColor: Color? = null
    var disabledIndeterminateBorderColor: Color? = null
}

@Composable
internal fun takeGlobalCheckboxColors(): CheckboxColors {
    val global = CheckBoxColorScheme
    val default = CheckboxDefaults.colors()
    return CheckboxDefaults.colors().define(global, default)
}

@Composable
private fun CheckboxColors.define(
    global: CheckBoxColorScheme,
    default: CheckboxColors
): CheckboxColors {
    return this.copy(
        checkedCheckmarkColor = global.checkedCheckmarkColor ?: default.checkedCheckmarkColor,
        uncheckedCheckmarkColor = global.uncheckedCheckmarkColor ?: default.uncheckedCheckmarkColor,
        checkedBoxColor = global.checkedBoxColor ?: default.checkedBoxColor,
        uncheckedBoxColor = global.uncheckedBoxColor ?: default.uncheckedBoxColor,
        disabledCheckedBoxColor = global.disabledCheckedBoxColor ?: default.disabledCheckedBoxColor,
        disabledUncheckedBoxColor = global.disabledUncheckedBoxColor
            ?: default.disabledUncheckedBorderColor,
        disabledIndeterminateBoxColor = global.disabledIndeterminateBoxColor
            ?: default.disabledIndeterminateBoxColor,
        checkedBorderColor = global.checkedBorderColor ?: default.checkedBorderColor,
        uncheckedBorderColor = global.uncheckedBorderColor ?: default.uncheckedBorderColor,
        disabledBorderColor = global.disabledBorderColor ?: default.disabledBorderColor,
        disabledUncheckedBorderColor = global.disabledUncheckedBorderColor
            ?: default.disabledUncheckedBorderColor,
        disabledIndeterminateBorderColor = global.disabledIndeterminateBorderColor
            ?: default.disabledIndeterminateBorderColor,
    )
}